// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Jx6g","info":"Note_info__31Tkv","note":"Note_note__2mHNP","actions":"Note_actions__2gXtw"};